module.exports = __webpack_public_path__ + "static/front-6b38f4d99be2fe803b1f321976c998f0.jpg";